<template>
  <div class="cycle-automations mt-3" data-testid="cycle-automations">
    <p v-if="!canManage" class="caption">You do not have access to Automations for this cycle.</p>
    <template v-else>
      <div class="fc-cycle-automations-intro">
        <v-icon small color="#828285">mdi-information-outline</v-icon>
        <span>
          Automations running in this close. Copied from Setup › Automations › Templates when the cycle was created —
          changes here affect this cycle only. Emails stop when the cycle is closed.
        </span>
        <span class="fc-cycle-automations-intro__spacer" />
        <span class="fc-cycle-automations-intro__tz">{{ timezoneLabel }}</span>
      </div>
      <CycleEscalationsSection
        :cycle-id="cycleId"
        :closed="isClosed"
        @edit="openForm('escalation', $event)"
      />
      <CycleDigestsSection
        :cycle-id="cycleId"
        :closed="isClosed"
        class="mt-6"
        @edit="openForm('digest', $event)"
      />
      <EscalationFormDialog
        :value="dialog.open && dialog.kind === 'escalation'"
        :notification="dialog.notification"
        :cycle-id="cycleId"
        @input="onDialogInput"
        @saved="onSaved('escalation')"
      />
      <DashboardDigestFormDialog
        :value="dialog.open && dialog.kind === 'digest'"
        :notification="dialog.notification"
        :cycle-id="cycleId"
        @input="onDialogInput"
        @saved="onSaved('digest')"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FC_ROUTES } from '../../../../utils/constants';
import { browserTimezoneLabel } from '../../../../utils/notificationScheduleUtils';
import { canManageCycleAutomations } from '../../../../utils/notificationAccess';
import CycleEscalationsSection from './components/CycleEscalationsSection.vue';
import CycleDigestsSection from './components/CycleDigestsSection.vue';
import EscalationFormDialog from './components/EscalationFormDialog.vue';
import DashboardDigestFormDialog from './components/DashboardDigestFormDialog.vue';

export default {
  name: 'CycleAutomations',
  components: {
    CycleEscalationsSection,
    CycleDigestsSection,
    EscalationFormDialog,
    DashboardDigestFormDialog,
  },
  data() {
    return {
      dialog: { open: false, kind: 'digest', notification: {} },
    };
  },
  computed: {
    ...mapGetters('emailNotifications', { notificationEnabled: 'fetchNotificationEnabled' }),
    ...mapGetters('project', ['cycleManagerIds']),
    ...mapGetters('dashboard', ['isCycleInActive']),
    cycleId() {
      return this.$route.params.id;
    },
    canManage() {
      return canManageCycleAutomations({
        clientNotificationEnabled: this.notificationEnabled,
        managerIds: this.cycleManagerIds(this.cycleId),
        userId: this.$store.state.user?._id || this.$store.state.user?.id,
        isFinancialCloseAdmin: this.$store.state.clientDetails?.isFinancialCloseAdmin,
      });
    },
    isClosed() {
      return this.isCycleInActive === true;
    },
    timezoneLabel() {
      return browserTimezoneLabel();
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('emailNotifications/fetchNotificationEnabled'),
      this.$store.dispatch('emailNotifications/fetchLocations'),
      this.$store.dispatch('emailNotifications/fetchCategories'),
      this.$store.dispatch('project/fetchCycleUserDetails', this.cycleId),
    ]);
    if (!this.canManage) {
      const path = FC_ROUTES.CYCLE_SETTINGS_TEAM(this.cycleId);
      this.$router.replace({ path, query: this.$route.query }).catch(() => {});
    }
  },
  methods: {
    openForm(kind, notification) {
      this.dialog = {
        open: true,
        kind,
        notification: notification && notification._id ? notification : {},
      };
    },
    onDialogInput(open) {
      if (!open) this.dialog = { ...this.dialog, open: false };
    },
    onSaved(kind) {
      if (kind === 'escalation') {
        this.$store.dispatch('tasks/getAllTaskEmailNotifications', { cycleId: this.cycleId });
      } else {
        this.$store.dispatch('dashboard/getAllEmailNotifications', { cycleId: this.cycleId });
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../../components/Notifications/notificationLayout.scss';
</style>
